import { render, staticRenderFns } from "./UserAnnouncementList.vue?vue&type=template&id=02a31774&scoped=true&"
import script from "./UserAnnouncementList.vue?vue&type=script&lang=js&"
export * from "./UserAnnouncementList.vue?vue&type=script&lang=js&"
import style0 from "./UserAnnouncementList.vue?vue&type=style&index=0&id=02a31774&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02a31774",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('02a31774')) {
      api.createRecord('02a31774', component.options)
    } else {
      api.reload('02a31774', component.options)
    }
    module.hot.accept("./UserAnnouncementList.vue?vue&type=template&id=02a31774&scoped=true&", function () {
      api.rerender('02a31774', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/UserAnnouncementList.vue"
export default component.exports